import Vue from 'vue'
import request from '@/helpers/request'
import store from '@/store'
import backendValidationErrorHandling from '@/helpers/backendValidationErrorHandling'

export default {
  UPDATE_ACCOUNT_PROFILE: ({ commit, state }, payload) => {
    const message = payload.message
    const messageParam = payload.messageParam
    commit('setLoad', true)
    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.profile.update}`,
      payload.params,
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const paramsObj = payload.params
        const paramsKeys = Object.keys(paramsObj)
        _.each(paramsKeys, key => {
          if (store.state.user.hasOwnProperty(key)) {
            const valueObj = {
              key: key,
              value: paramsObj[`${key}`],
            }
            commit('setUserField', valueObj)
          }
        })
        commit('setLoad', false)
        Vue.notify({
          type: `success`,
          text: `${message} <br> ${messageParam ? messageParam : ''}`,
        })
      } else {
        // TODO: Show error dialog
      }
    })
  },
  UPDATE_ACCOUNT_PROFILE_IMG: ({ commit, state }, payload) => {
    const message = payload.message
    const messageError = payload.messageError
    const filesizeError = payload.filesizeError
    // TODO refactor to standart actions
    axios
      .post(`${Vue.config.server}/${Vue.config.modules.crm.api.employers.profile.update}`, payload.formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(response => {
        if (response.data.result === 'success' && response.data.data.avatar.filename) {
          const FILE_PATH = response.data.data.avatar.filename
          commit('setUserAvatar', FILE_PATH)
          Vue.notify({
            title: '',
            type: `success`,
            text: `${message}`,
          })
        } else {
          Vue.notify({
            title: '',
            type: `error`,
            text: `${messageError}`,
          })
        }
      })
      .catch(error => {
        Vue.notify({
          title: '',
          type: `error`,
          text: `${messageError} <br> ${filesizeError} `,
        })
      })
  },
  REQUEST_PROFILE_CHANGE: ({ commit, state }, payload) => {
    const message = payload.message
    const messageParam = payload.messageParam
    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.profile.update}`,
      payload.params,
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        if (payload.params.phone != null) {
          commit('setSmsInputView', true)
        }
        Vue.notify({
          title: '',
          type: `success`,
          text: `${message} <br> ${messageParam ? messageParam : ''}`,
        })
      } else {
        // TODO: Show error dialog
      }
    })
  },
  CHECK_PROFILE_TOKEN: ({ commit, state }, payload) => {
    const message = payload.message
    const messageError = payload.messageError
    const messageParam = payload.messageParam
    const fieldType = payload.params.type
    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.profile.checkToken}`,
      payload.params,
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          if (fieldType === 'phone') {
            commit('setSmsInputView', false)
          }
          if (fieldType === 'email') {
            commit('setEmailConfirmedMessage', message)
          }
          Vue.notify({
            title: '',
            type: `success`,
            text: `${message} ${messageParam ? messageParam : ''}`,
          })
        } else {
          if (fieldType === 'email') {
            commit('setEmailConfirmedMessage', messageError)
          }
          Vue.notify({
            title: '',
            type: `error`,
            text: `${messageError} ${messageParam ? messageParam : ''}`,
          })
        }
      })
      .catch(error => {
        if (fieldType === 'email') {
          commit('setEmailConfirmedMessage', messageError)
        }
      })
  },
  RESET_PROFILE_PASSWORD: ({ commit, state }, payload) => {
    const message = payload.message
    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.profile.changePassword}`,
      payload.params,
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          Vue.notify({
            title: '',
            type: `${response.data.result}`,
            text: `${message}`,
          })
        }
      })
      .catch(error => {
        backendValidationErrorHandling(error, 'Ошибка смены пароля')
      })
  },
}
